const DownloadIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="63"
      height="63"
      viewBox="0 0 63 63"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_d_3592_248446)">
        <circle cx="29.5" cy="26.5" r="21.5" fill="white" />
        <circle cx="29.5" cy="26.5" r="21" stroke="#FCF7F7" />
      </g>
      <g clipPath="url(#clip0_3592_248446)">
        <path
          d="M29.2934 33.0395C29.3168 33.0629 29.3413 33.085 29.3669 33.106C29.3782 33.1152 29.39 33.1232 29.4016 33.1319C29.4161 33.1428 29.4304 33.1541 29.4455 33.1641C29.4596 33.1736 29.4743 33.1818 29.4888 33.1905C29.5022 33.1985 29.5154 33.207 29.5293 33.2144C29.5442 33.2224 29.5595 33.2291 29.5747 33.2363C29.589 33.2431 29.6032 33.2503 29.6179 33.2563C29.6328 33.2625 29.6479 33.2675 29.663 33.2728C29.6787 33.2785 29.6942 33.2845 29.7102 33.2893C29.7253 33.2939 29.7406 33.2973 29.7558 33.3011C29.7722 33.3052 29.7884 33.3098 29.8051 33.3131C29.8226 33.3166 29.8404 33.3187 29.858 33.3212C29.8726 33.3233 29.887 33.3261 29.9019 33.3275C29.9347 33.3307 29.9676 33.3325 30.0006 33.3325C30.0335 33.3325 30.0664 33.3308 30.0992 33.3275C30.1142 33.3261 30.1288 33.3233 30.1436 33.3211C30.1611 33.3187 30.1786 33.3166 30.1959 33.3131C30.2129 33.3098 30.2295 33.3051 30.2462 33.3009C30.261 33.2971 30.276 33.2939 30.2908 33.2894C30.3072 33.2844 30.323 33.2783 30.339 33.2725C30.3538 33.2672 30.3686 33.2624 30.3832 33.2564C30.3982 33.2502 30.4125 33.2429 30.4271 33.236C30.4421 33.2289 30.4572 33.2223 30.4719 33.2144C30.4859 33.2069 30.4991 33.1985 30.5126 33.1903C30.5271 33.1817 30.5418 33.1735 30.5558 33.1641C30.5706 33.1542 30.5846 33.1431 30.5988 33.1325C30.6107 33.1236 30.6229 33.1153 30.6345 33.1059C30.6588 33.0859 30.6821 33.0647 30.7044 33.0426C30.7055 33.0415 30.7067 33.0407 30.7077 33.0397L35.3745 28.3731C35.765 27.9826 35.765 27.3495 35.3745 26.9589C34.984 26.5685 34.3508 26.5684 33.9603 26.9589L31.0006 29.9184V17.666C31.0006 17.1137 30.5528 16.666 30.0006 16.666C29.4483 16.666 29.0006 17.1137 29.0006 17.666V29.9183L26.0411 26.9589C25.6506 26.5684 25.0174 26.5684 24.6269 26.9589C24.2364 27.3495 24.2364 27.9826 24.6269 28.3731L29.2934 33.0395Z"
          fill="#606062"
        />
        <path
          d="M40 26.666C39.4477 26.666 39 27.1137 39 27.666V35.3327H21V27.666C21 27.1137 20.5523 26.666 20 26.666C19.4477 26.666 19 27.1137 19 27.666V36.3327C19 36.8849 19.4477 37.3327 20 37.3327H40C40.5523 37.3327 41 36.8849 41 36.3327V27.666C41 27.1137 40.5523 26.666 40 26.666Z"
          fill="#606062"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_3592_248446"
          x="0"
          y="0"
          width="63"
          height="63"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="2" dy="5" />
          <feGaussianBlur stdDeviation="5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.909804 0 0 0 0 0.313726 0 0 0 0 0.313726 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3592_248446"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3592_248446"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_3592_248446">
          <rect
            width="22"
            height="22"
            fill="white"
            transform="translate(19 16)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DownloadIcon;
